(() => {
  if (window.hrSearchReady) return;
  window.hrSearchReady = true;
  const start = () => {
    const url = new URL(location.href);
    const params = url.searchParams;
    const raw = params.get('hr_term') ?? params.get('q') ?? '';
    const literal = text => '"' + text.replace(/[\\"]/g, '\\$&') + '"';
    const build = (term, mode, path, form) => {
      const words = term.trim().split(/\s+/).filter(Boolean);
      let query = '*';
      if (words.length) {
        const titles = words.map(word => 'title:' + literal(word) + '*').join(' AND ');
        query = mode === 'descriptions' ? words.map(literal).join(' AND ') : '(' + titles + ' OR variants.sku:' + literal(term.trim()) + ')';
      }
      if (path === 'bulk') query += ' AND title:bulk';
      if (path === 'retail') query += ' AND -title:bulk';
      if (form === 'powder' || form === 'capsules') query += ' AND title:' + form;
      return query;
    };
    document.querySelectorAll('.hr-search .pagination a').forEach(link => {
      const target = new URL(link.href);
      ['hr_term','hr_search','hr_mode','hr_path','hr_form'].forEach(key => {
        if (params.has(key)) target.searchParams.set(key,params.get(key));
      });
      link.href = target.href;
    });
    const forms = document.querySelectorAll('form[role="search"]');
    forms.forEach(form => {
      const input = form.querySelector('[name="q"]');
      if (!input) return;
      input.value = raw;
      const panel = form.querySelector('.hr-search-controls');
      if (panel) {
        panel.hidden = false;
        ['hr_mode','hr_path','hr_form','filter.v.availability'].forEach(name => {
          const select = form.elements.namedItem(name);
          const value = params.get(name);
          if (select && value && Array.from(select.options).some(option => option.value === value)) select.value = value;
        });
      }
      const resetFilters = broaden => {
        ['hr_path','hr_form','filter.v.availability'].forEach(name => {
          const select = form.elements.namedItem(name);
          if (select) select.selectedIndex = 0;
        });
        const mode = form.elements.namedItem('hr_mode');
        if (mode) mode.value = broaden ? 'descriptions' : 'names';
        form.requestSubmit();
      };
      const reset = form.querySelector('[data-hr-search-reset]');
      if (reset) {
        reset.hidden = false;
        reset.addEventListener('click', () => resetFilters(false));
      }
      if (panel) {
        document.querySelectorAll('[data-hr-search-broaden]').forEach(button => {
          button.hidden = false;
          button.addEventListener('click', () => resetFilters(true));
        });
      }
      form.addEventListener('submit', event => {
        event.preventDefault();
        const target = new URL(form.action);
        const data = new FormData(form);
        const term = input.value.trim();
        const mode = data.get('hr_mode') || 'names';
        const path = data.get('hr_path') || 'all';
        const productForm = data.get('hr_form') || 'all';
        data.set('q', build(term,mode,path,productForm));
        data.set('hr_term',term);
        data.set('hr_search','1');
        data.set('hr_mode',mode);
        data.set('hr_path',path);
        data.set('hr_form',productForm);
        data.forEach((value,key) => { if(value !== '') target.searchParams.set(key,value); });
        location.assign(target.href);
      });
    });
    if (document.querySelector('[data-hr-search]') && params.has('q') && !params.has('hr_search')) {
      params.set('q',build(raw,'names','all','all'));
      params.set('hr_term',raw);
      params.set('hr_search','1');
      params.set('type','product');
      params.set('options[prefix]','last');
      location.replace(url.href);
    }
  };
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true}); else start();
})();
